//React
import { useState, useEffect, useRef } from "react";

//Chakra
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  SimpleGrid,
  VStack,
  Box,
  Text,
  Flex,
  Button,
  Center,
  Input,
  FormControl,
  Textarea,
  FormErrorMessage,
  Select,
  Heading,
  Avatar,
  Square,
  //hooks
  useToast,
  useDisclosure,
} from "@chakra-ui/react";

//Custom Component
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.js";

//Endpoint
import { useFormik } from "formik";
import * as Yup from "yup";
import { blastToAllUsers } from "service/blast.service";
import { blastChatToAllUsers } from "service/blast.service";

//Package
const {
  useHistory,
  useLocation,
  useParams,
} = require("react-router-dom/cjs/react-router-dom.min");

export default function BlastChatForm() {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);
  // variable

  const route_param = useParams();
  const history = useHistory();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  //form

  const formik = useFormik({
    initialValues: {
      env: "",
      title: "",
      body: "",
      image_url: "",
      click_action: "",
    },

    validationSchema: Yup.object().shape({
      env: Yup.string().required("required"),
      title: Yup.string().required("required"),
      body: Yup.string().required("required"),
      image_url: Yup.string().required("required"),
      click_action: Yup.string().required("required"),
    }),

    onSubmit: async (values) => {
      try {
        const res = await blastChatToAllUsers(values);
        if (res)
          toast({
            title: "Message blasted.",
            description: "Message blasted to all users chats.",
            status: "success",
            duration: 9000,
            isClosable: true,
            position: "bottom-left",
          });
      } catch (error) {
        toast({
          title: "Message blasted fail.",
          description: "Message blasted to all users chats failed.",
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "bottom-left",
        });

        console.log(error);
      }
    },
  });

  //methods

  // Handle the file input change event
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setSelectedImage(e.target.result);
      };

      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  // Handle the URL input change event
  const handleUrlChange = (e) => {
    const url = e.target.value;
    formik.setFieldValue("image_url", e.target.value);
    setImageUrl(url);
  };

  //setup
  useEffect(() => {
    // getOrder(route_param.orderId);
  }, []);

  //component

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
        <CardHeader p="6px 0px 22px 0px">
          <Text
            fontSize="lg"
            color="#fff"
            fontWeight="bold"
            textColor={"blue.200"}
            textTransform={"uppercase"}
          >
            Blast admin message to Chat
          </Text>
        </CardHeader>
        <CardBody w={"full"}>
          <SimpleGrid
            w={"full"}
            my={"4"}
            px={"4"}
            columns={{ base: 1, md: 2 }}
            spacing={{ base: "12", md: "12" }}
          >
            <FormControl isInvalid={!!(formik?.errors.env && formik?.touched.env)}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Environment</Text>
                {/* <Input {...formik.getFieldProps("env")} bg={"white"} /> */}
                <Select
                  textColor={"black"}
                  variant={"app-outline"}
                  {...formik.getFieldProps("env")}
                  placeholder="Choose one"
                >
                  <option value={"staging"}>Staging</option>
                  <option value={"production"}>Production</option>
                </Select>
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.env}
                </FormErrorMessage>
              </VStack>
            </FormControl>

            <FormControl isInvalid={!!(formik?.errors.title && formik?.touched.title)}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Title</Text>
                <Input {...formik.getFieldProps("title")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.title}
                </FormErrorMessage>
              </VStack>
            </FormControl>

            <FormControl
              isInvalid={!!(formik?.errors.click_action && formik?.touched.click_action)}
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Link to Click</Text>
                <Input {...formik.getFieldProps("click_action")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.click_action}
                </FormErrorMessage>
              </VStack>
            </FormControl>

            <FormControl
              isInvalid={!!(formik?.errors.image_url && formik?.touched.image_url)}
            >
              <VStack alignItems={"start"} my={"3"}>
                <Flex alignItems={"baseline"}>
                  <Text color={"white"}>Image URL </Text>
                  <Text color={"white"} mx={"1"} fontSize={"xs"} textColor={"red.300"}>
                    (16:9 for full display)
                  </Text>
                </Flex>

                <Input
                  {...formik.getFieldProps("image_url")}
                  bg={"white"}
                  onChange={(e) => {
                    // console.log("image_url", e);
                    handleUrlChange(e);
                  }}
                />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.image_url}
                </FormErrorMessage>
                {/* <Input
                  // isDisabled={isDisabled}
                  // multiple={isMultiple}
                  // accept={accept}
                  // ref={fileInputRef}
                  bg={"white"}
                  type={"file"}
                  variant={"app-outline"}
                  pr="5.5rem"
                  py={"1"}
                  sx={{ "::file-selector-button": { display: "none" } }}
                  onChange={(e) => {
                    // console.log("image_url", e);
                    handleImageChange(e);
                  }}
                  onBlur={() => {
                    // if (blurHandler) blurHandler(inputName, true);
                  }}
                /> */}
                {imageUrl ? (
                  <Box>
                    <img
                      src={imageUrl}
                      alt="Selected"
                      style={{ maxWidth: "100%", maxHeight: "300px" }}
                    />
                  </Box>
                ) : (
                  <Square size={"300px"} bg={"gray.400"} rounded={"md"} />
                )}
              </VStack>
            </FormControl>

            <FormControl isInvalid={!!(formik?.errors.body && formik?.touched.body)}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Body</Text>
                <Textarea {...formik.getFieldProps("body")} bg={"white"} rows={10} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.body}
                </FormErrorMessage>
              </VStack>
            </FormControl>
          </SimpleGrid>
        </CardBody>

        <Center>
          <Button
            variant="brand"
            fontSize="15px"
            type="submit"
            w="100%"
            maxW="350px"
            h="45"
            mb="20px"
            mt="20px"
            mx={"2"}
            textTransform={"uppercase"}
            fontWeight={"extrabold"}
            backgroundColor={"green.500"}
            isLoading={formik.isSubmitting}
            onClick={onOpen}
            isDisabled={formik.isLoading || !formik.isValid}
          >
            Blast To All Users
          </Button>
        </Center>
      </Card>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Blast to all users
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="green"
                onClick={() => {
                  formik.submitForm();
                  onClose();
                }}
                ml={3}
              >
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
}
